import { useQuery } from "@tanstack/react-query";
import formatCategories from "src/helpers/formatCategories";
import newApi from "src/newApi";

import isPes from "../helpers/isPes";
import options from "./defaultOptions";

export function useGetCemVersions() {
	return useQuery({
		queryKey: ["cem-versions"],
		queryFn: () => newApi.getCemVersions(),
		...options,
		enabled: !isPes(),
	});
}

export function useDepartments() {
	const specId = newApi.getUserSpecialization();
	const queryKey = isPes() ? `departments-pes-${specId}` : "departments-lek";

	return useQuery({
		queryKey: [queryKey],
		queryFn: async () => {
			const data = await newApi.getCategories();
			return formatCategories(data);
		},
		...options,
	});
}
